
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/emoji-flags.css'

// Register service worker for caching
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

// Add comprehensive security headers via meta tags
const addSecurityHeaders = () => {
  // Add stricter Content Security Policy meta tag with specific hashes for inline styles
  const cspMeta = document.createElement('meta');
  cspMeta.httpEquiv = 'Content-Security-Policy';
  
  // Vercel config with optimized CSP
  cspMeta.content = "default-src 'self'; script-src 'self' 'unsafe-inline' https://www.fxblue.com https://api.fxblue.com https://va.vercel-scripts.com; style-src 'self' https://fonts.googleapis.com 'unsafe-inline'; font-src 'self' https://fonts.gstatic.com; img-src 'self' data: https:; connect-src 'self' https://api.theclub.finance https://*.supabase.co https://*.supabase.in https://api.ipify.org https://*.vercel.app wss://*.supabase.co https://www.fxblue.com https://api.fxblue.com https://va.vercel-scripts.com; frame-src 'self' https://www.youtube.com https://www.youtube-nocookie.com https://www.fxblue.com https://api.fxblue.com; form-action 'self'; base-uri 'self'; object-src 'none'; upgrade-insecure-requests;";
  document.head.appendChild(cspMeta);
  
  // Add X-Frame-Options to prevent clickjacking
  const xframeMeta = document.createElement('meta');
  xframeMeta.httpEquiv = 'X-Frame-Options';
  xframeMeta.content = 'DENY';
  document.head.appendChild(xframeMeta);
  
  // Add X-Content-Type-Options to prevent MIME-type sniffing
  const xContentTypeMeta = document.createElement('meta');
  xContentTypeMeta.httpEquiv = 'X-Content-Type-Options';
  xContentTypeMeta.content = 'nosniff';
  document.head.appendChild(xContentTypeMeta);
  
  // Add Referrer-Policy
  const referrerMeta = document.createElement('meta');
  referrerMeta.name = 'referrer';
  referrerMeta.content = 'strict-origin-when-cross-origin';
  document.head.appendChild(referrerMeta);
  
  // Add Permissions-Policy to limit features
  const permissionsMeta = document.createElement('meta');
  permissionsMeta.httpEquiv = 'Permissions-Policy';
  permissionsMeta.content = 'camera=(), microphone=(), geolocation=()';
  document.head.appendChild(permissionsMeta);
};

// Execute security headers function
addSecurityHeaders();

createRoot(document.getElementById("root")!).render(
  <App />
);
